import { Component, ChangeDetectionStrategy } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ContactService } from '../../services/contact.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';

@Component({
  selector: 'app-install-mobile-app',
  standalone: false,
  templateUrl: './install-mobile-app.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./install-mobile-app.component.scss'],
})
export class InstallMobileAppComponent {
  contactForm: FormGroup;
    captchaQuestion: string = '';
  captchaAnswer: number = 0;
  emailSent: boolean = false;

  constructor() { }


  ngOnInit(): void {
  }

}
